import { SetState, StoreData } from "../types";

export const setIntegrationId = (set: SetState<StoreData>) => (integrationId?: string) => set({ integrationId });
